module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_6.8ce6e6f7.png";